import React from 'react'
import { CreateLoungeScreen } from '@/screens/lounges/CreateLoungeScreen'

export default function CreateLoungeRoute() {
  return <CreateLoungeScreen />
}
